<!--
 * @Descripttion: 
 * @Author: chenxt
 * @Date: 2023-11-20 16:22:03
-->
<template>
  <div id="marketInspection" >
    <van-nav-bar title="市场巡查" left-text="返回" left-arrow @click-left="onClickLeft"></van-nav-bar>
    <div class="top">
      <div class="top-til" @click="handleInspectionRecord('add')">
        +添加巡查记录
      </div>
    </div>
    <div class="con">
      <div class="con-item" v-for="(item, index) in list" :key="index">
        <div class="con-til">
          <div class="con-till">{{ item.title }}</div>
          <div class="con-tip" v-if="item.state == 0">已上报</div>
          <div class="con-tip" v-if="item.state == 2">{{ item.stateName }}</div>
        </div>
        <van-divider class="con-item-divider" />
        <div class="con-bottom">
          <div class="con-msg">
            <div class="p">巡查时间：<div class="msg-item">{{ item.createTime }}</div></div>
            <div class="p">巡查地点：<div class="msg-item">{{ item.address }}</div></div>
            <div class="p">巡查描述：<div class="msg-item">{{ item.remark }}</div>
            </div>
          </div>
          <div class="con-btns">
            <div
              v-if="item.state == 1"
              class="btn-item"
              @click="handleInspectionRecord('modify', item)"
            >
              修改
            </div>
            <div v-if="item.state == 1" class="btn-item" @click="handleInspectionRecord('del', item)">
              删除
            </div>
            <div
              v-else
              class="btn-item"
              @click="handleInspectionRecord('modify', item)"
            >
              查看
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loading } from "@/common/loading";
import {getUserInfoAjax2,
      getWarnInspection,
      deleteWarnInspectionById} from '@/api/baseMsg';
import {removeToken} from '@/utils/auth'
import { Toast } from "vant";
export default {
  name: "marketInspection",
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.init();//初始化
  },
  methods: {
    init() {
      // setToken('0f5d253a-b7fe-4f2e-81af-15355175adfe')
      loading(true);
      this.checkLogin()
      this.xuanBiao();
    },
    xuanBiao(val) {
      const params = {
        title:''
      }
      getWarnInspection(params).then(res=> {
        if(res.code == 200) {
          this.list = res.data
        }else {
          this.list = []
        }
        if(val == 'query'){
          setTimeout(()=> {
            loading(false)
          },1000)
        }else {
          loading(false)
        }
      })
    },
    // 返回
    onClickLeft() {
      this.$router.push({
          path: '/',
      });
    },
    checkLogin() {
      const loginType = this.$store.state.login.loginType;
      if(loginType == 1) {
        // 小程序登录
        loading(true)
        getUserInfoAjax2().then(res=> {
        if(res.code == 200) {
            if(!res.data.openId){
            removeToken()
            this.$router.push({ path: '/login'});
            }
        }
            loading(false)
        })
      }
    },
    // 按钮事件函数
    handleInspectionRecord(val, row) {
      switch (val) {
        case "add":
          this.$router.push("/marketInspectionModify");
          break;
        case "modify":
          this.$router.push({
            path: "/marketInspectionModify",
            query: {
              ...row
            },
          });
          break;
        case "del":
          this.$dialog
            .confirm({
              message: "是否确认删除?",
            })
            .then(() => {
              loading(true)
              const params = {
                ids: row.Id
              }
              deleteWarnInspectionById(params).then(res=> {
                if(res.code == 200) {
                  Toast.success(res.message || '删除成功')
                }else {
                  Toast.fail(res.message || '删除失败!')
                }
                this.xuanBiao('query')
              })
            })
            .catch(() => {});
          break;
      }
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
#marketInspection {
  background: #f1f1f1;
  height: 100%;
  /deep/.van-nav-bar__content{
    height: 100%;
    .van-nav-bar__title {
        margin-top: 0.1rem;
    }
    .van-nav-bar__left {
        margin-top: 0.1rem;
        padding-left: 0px;
    }
  }
  .top {
    height: 2rem;
    display: flex;
    align-items: center;
    .top-til {
      margin: 0 auto;
      text-align: center;
      width: 40%;
      height: 1rem;
      line-height: 1rem;
      background-color: #fff;
      font-size: px2rem(40);
      color: #9c9c9c;
      border-radius: 0.5rem;
    }
  }
  .con {
    .con-item {
      background-color: #fff;
      margin-bottom: 0.24rem;
      font-size: px2rem(40);
      padding: 0.3rem 0px;
      .con-til {
        border-left: 7px solid #4888bf;
        padding-left: 10px;
        font-weight: 550;
        display: flex;
        &::before {
          content: "";
          background-color: #4489ca;
        }
        .con-till {
          width: 85%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .con-tip {
          color: green;
          margin-right:10px;
          font-size: px2rem(36);
        }
      }
      .con-item-divider {
        margin: 8px 0;
        color: #e4e4e4;
        border: none;
        border-bottom: 2px solid #e4e4e4;
      }
      .con-bottom {
        height: 1.8rem;
        padding: 0 0.35rem;
        display: flex;
        justify-content: space-between;
        .con-msg {
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          width: calc(100% - 100px);
          .p {
            display:flex;
            line-height: 0.5rem;
          }
          .msg-item {
            font-weight: 550;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 60%;
          }
        }
        .con-btns {
          display: flex;
          align-items: flex-end;
          .btn-item {
            height: 0.8rem;
            width: 1.2rem;
            background-color: #298ff1;
            color: #fff;
            border-radius: 0.2rem;
            margin-left: 0.2rem;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
  }
}
</style>